export default "__VITE_ASSET__aoy2jgq8__"